import { PropsWithChildren } from 'react'
import { Box, Container, SxProps, Theme } from '@mui/material'

import { formWrapStyles } from 'common/styles'
import { Footer } from 'components/Footer'
import { Sidebar } from 'components/Sidebar'
import StyledWrap from 'components/StyledWrap'
import { useFlow } from 'utils/flow'

import SubHeader from './SubHeader'

const styles: Record<string, SxProps<Theme>> = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100vh',
    width: '100%',
    paddingRight: {
      xs: '20px',
      md: '24px',
    },
    paddingLeft: {
      xs: '20px',
      md: '24px',
    },
  },
}

const StepContainer = ({ children }: PropsWithChildren): JSX.Element => {
  const { data: flowData } = useFlow()

  return (
    <>
      <Sidebar />
      <StyledWrap wrapCss="width: 100%;" elementName="FormContainer">
        <Box className="main-content" sx={styles.mainContainer}>
          <SubHeader />
          <Container disableGutters sx={formWrapStyles.container}>
            <Box className="main-content-inner" sx={formWrapStyles.box}>
              {children}
            </Box>
          </Container>
          {flowData?.footer_enabled === true && <Footer content={flowData.footer_content} />}
        </Box>
      </StyledWrap>
    </>
  )
}

export default StepContainer
